import { DEFAULT_INFRASTRUCTURE_POI_TYPE } from '../../components/DistrictInfrastructureMap/constants';
import { TInfrastructurePoiType } from '../../types/infrastructure';

/** Тип по умолчанию для чипсов карты района: метро, а если станций рядом нет — первый доступный по порядку макета. */
export function getDefaultPoiType(availableTypes: readonly TInfrastructurePoiType[]): TInfrastructurePoiType | null {
  return availableTypes.includes(DEFAULT_INFRASTRUCTURE_POI_TYPE)
    ? DEFAULT_INFRASTRUCTURE_POI_TYPE
    : (availableTypes[0] ?? null);
}
